import './category-color-chart.style.sass';
import template from './category-color-chart.tpl.pug';

class CategoryColorChartController {
    /* @ngInject */
    constructor(arrayUtil) {
        this.arrayUtil = arrayUtil;
    }

    $onChanges(changeObject) {
        if (changeObject.entries) {
            this.entries = this.fixPercentage(changeObject.entries.currentValue || []);
        }
    }

    fixPercentage(entries) {
        let total = entries.reduce((total, entry) => total + entry.percent, 0);
        let ratio = 100 / total;

        return entries.map((entry) => {
            return {
                label: entry.label,
                color: entry.color,
                percent: entry.percent * ratio
            };
        }).sort((current, next) => next.percent - current.percent);
    }
}

export default {
    selector: 'dbACategoryColorChart',
    template: template(),
    controller: CategoryColorChartController,
    bindings: {
        entries: '<'
    }
};



// WEBPACK FOOTER //
// ./src/application/scene/authorized/scene/calendar/component/calendar-dashboard/component/category-color-chart/category-color-chart.cmpt.js